import VendorsPage from "src/pages/Legal/Vendors";
export default VendorsPage;
